import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {User, Response, RegistrationData} from '../models/models';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClient: HttpClient) { }

  getUsersByRight(userId: number): Observable<Response<User[]>> {
    return this.httpClient.get<Response<User[]>>(environment.apiPath + 'User/' + userId + '/UserId/GetUsersByRight');
  }

  getUserById(id: number): Observable<Response<User>> {
    return this.httpClient.get<Response<User>>(environment.apiPath + 'User/' + id);
  }

  checkIfEmailExists(email: string): Observable<Response<boolean>> {
    return this.httpClient.get<Response<boolean>>(environment.apiPath + 'User/' + email + '/CheckIfEmailExists');
  }

  insertUser(user: User): Observable<Response<User>> {
    return this.httpClient.post<Response<User>>(environment.apiPath + 'User/', user);
  }

  updateUserFirstLogin(userId: number): Observable<Response<User>> {
    return this.httpClient.get<Response<User>>(environment.apiPath + 'User/' + userId + '/UserId/UpdateUserFirstLogin');
  }

  updateUserTermsAndConditionRead(userId: number): Observable<Response<User>> {
    return this.httpClient.get<Response<User>>(environment.apiPath + 'User/' + userId + '/UserId/UpdateUserTermsAndConditionRead');
  }

  updateUserLanguage(userId: number, language: string): Observable<Response<boolean>> {
    return this.httpClient.get<Response<boolean>>(environment.apiPath + 'User/' + userId + '/UserId/' + language + '/Language');
  }

  updateUserConfirmationMail(userId: number, confirmationMail: boolean, confirmationMailAsked): Observable<Response<boolean>> {
    return this.httpClient.get<Response<boolean>>(environment.apiPath + 'User/' + userId + '/UserId/' + confirmationMail + '/ConfirmationMail/' + confirmationMailAsked + '/ConfirmationMailAsked');
  }

  updateUser(id: number, user: User): Observable<Response<User>> {
    return this.httpClient.put<Response<User>>(environment.apiPath + 'User/' + id, user);
  }

  deleteUser(id: number): Observable<Response<boolean>> {
    return this.httpClient.delete<Response<boolean>>(environment.apiPath + 'User/' + id);
  }

  registration(registration: RegistrationData): Observable<Response<boolean>> {
    return this.httpClient.post<Response<boolean>>(environment.apiPath + 'Registration/', registration);
  }

  getTempRegistrationDataById(id: string): Observable<Response<RegistrationData>> {
    return this.httpClient.get<Response<RegistrationData>>(environment.apiPath + 'Registration/' + id + '/Id');
  }
}
